import { Link, useParams } from "react-router-dom";
import Button from "../../../ReusableComponent/Button";

const AssessmentButton = ({
  currentPage,
  handleClick,
  handleSubmit,
  quizTestsQuestions = [],
}) => {
  const { id } = useParams();

  return (
    <>
      <div className="row mx-0">
        <div className="col-12 py-2">
          {currentPage < quizTestsQuestions.length - 1 && (
            <div className="btn-next d-flex px-3">
              <Button
                variant="gradient"
                fullWidth
                onClick={() => {
                  handleClick();
                }}
              >
                {" "}
                <b>Next</b>
              </Button>
            </div>
          )}
          {currentPage === quizTestsQuestions.length - 1 && (
            <div className="">
              {/* <Link
                to={`/assessment/test/${id}/report`}
                className="text-decoration-none d-flex btn-next"
              > */}
                <Button
                  variant="gradient"
                  fullWidth
                  onClick={() => {
                    handleClick();
                    handleSubmit();
                  }}
                >
                  {" "}
                  <b>Finish</b>
                </Button>
              {/* </Link> */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AssessmentButton;
